import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-lock-account-dialog',
  templateUrl: './lock-account-dialog.component.html',
  styleUrls: ['./lock-account-dialog.component.less']
})
export class LockAccountDialogComponent {

  constructor(
    private dialogRef: MatDialogRef<LockAccountDialogComponent>
  ) {}

  confirm(): void {
    this.dialogRef.close(true);
  }

  cancel(): void {
    this.dialogRef.close(false);
  }
}